/**
 * Full-page loading overlay when ticket overview filters, sort, or list facet links navigate via GET.
 * Form submits (search, date filters, bulk actions) use initFormSubmitOverlay() instead.
 */

import { showFormSubmitLoadingOverlay } from '../components/form-submit-overlay';

const PAGE_MARKER = '[data-ticket-overview-page]';

function isTicketOverviewNavLink(anchor: HTMLAnchorElement): boolean {
    const href = anchor.getAttribute('href');
    if (!href || href.startsWith('#')) {
        return false;
    }
    try {
        const url = new URL(href, window.location.href);
        return url.pathname.endsWith('/ticket-overview');
    } catch {
        return href.includes('/ticket-overview');
    }
}

function shouldShowOverlayForClick(e: MouseEvent, anchor: HTMLAnchorElement): boolean {
    if (e.defaultPrevented) {
        return false;
    }
    if (e.button !== 0) {
        return false;
    }
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
        return false;
    }
    if (anchor.target === '_blank' || anchor.hasAttribute('download')) {
        return false;
    }
    return isTicketOverviewNavLink(anchor);
}

export function initTicketOverviewNavOverlay(): void {
    const pageRoot = document.querySelector(PAGE_MARKER);
    if (!pageRoot) {
        return;
    }

    pageRoot.addEventListener(
        'click',
        (e) => {
            const anchor = (e.target as Element | null)?.closest('a');
            if (!(anchor instanceof HTMLAnchorElement)) {
                return;
            }
            if (!shouldShowOverlayForClick(e, anchor)) {
                return;
            }
            showFormSubmitLoadingOverlay();
        },
        false
    );
}
